class ModalRequestRegisterLoginClass {
  constructor(){
    
    this.main = document.getElementById('modal_request_register_login');
    
    if(this.main){
      this._title = this.main.querySelector('.title');
      this._description = this.main.querySelector('.description');
      this._btnClose = this.main.querySelector('.btn_close');
      
      this._btnClose.addEventListener('click', this._onClickBtnClose.bind(this));
    }
  }
  
  show(title = null, description = null) {
    this.main.classList.add('modal--show');
    document.body.classList.add('block-scroll');

    if (title) {
      this._title.textContent = title;
    }

    if (description) {
      this._description.textContent = description;
    }

    setTimeout(() => {
      this.main.classList.add('modal--anim');
    }, 50);
  }

  hide(){
      this.main.classList.remove('modal--anim');

      setTimeout(()=>{
          this.main.classList.remove('modal--show');
          document.body.classList.remove('block-scroll');
      }, 750);
  }

  _onClickBtnClose(e) {
    e.preventDefault();

    this.hide();
  }
}

const ModalRequestRegisterLogin = new ModalRequestRegisterLoginClass();

Object.seal(ModalRequestRegisterLogin);

export default ModalRequestRegisterLogin;